module.exports = __webpack_public_path__ + "img/linha-integral.f27a9000.svg";